import { useEffect } from 'react';

/**
 * Disable vertical scrolling by removing y-axis overflow from the HTML.
 */
function useDisableScroll(disable = true) {
  const noVerticalScrollClassName = 'no-vertical-scroll';

  useEffect(() => {
    const htmlClasses = document.documentElement.classList;
    htmlClasses.toggle(noVerticalScrollClassName, disable);

    return () => htmlClasses.toggle(noVerticalScrollClassName, false);
  }, [disable]);
}

export default useDisableScroll;
